<div class="alarm-chart" *ngIf="loaded && alarmChartReady"
     [style.height.px]="chartHeight">
  <canvas baseChart
          [datasets]="alarmChartData"
          [labels]="[]"
          [options]="alarmChartOptions"
          [colors]="alarmChartColors"
          [legend]="alarmChartLegend"
          [chartType]="alarmChartType"></canvas>
</div>

<div class="chart-state" *ngIf="loading">
  <i class="fa fa-spinner fa-spin"></i> Cargando gráfico...
</div>
<div class="chart-state chart-state-error" *ngIf="!loading && error">
  <i class="fa fa-exclamation-triangle"></i> No fue posible cargar el gráfico.
</div>
<div class="chart-state" *ngIf="!loading && !error && loaded && !alarmChartReady">
  Sin alarmas para mostrar.
</div>
